export function ensureMimeTextCharset(mimeType: string): string {
  if (!mimeType.startsWith('text/')) {
    return mimeType;
  }
  if (mimeType.includes('charset')) {
    return mimeType;
  }
  return `${mimeType}; charset=utf-8`;
}
